// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__eCfN8","errors":"Errors_errors__3pAgd"};